import React, { useEffect, useState } from 'react';
import { useAwaitingActions } from '@vivli/features/dashboard/infrastructure/hook';
import { DashboardAdminComponent } from '@vivli/features/dashboard/components';
import {
    IDisclosuresActionsDetailsDto,
    IEnquiriesActionsDetailsDto,
    IRequestsUploadsActionsDetailListDto
} from '@vivli/features/dashboard/infrastructure/interface';
import { useAppConfigContext } from '@vivli/core/infrastructure/context';

export const DashboardFeature = () => {
    const awaitingActionsResults = useAwaitingActions();
    const [requestsDto, setRequestsDto] = useState<IRequestsUploadsActionsDetailListDto>(null);
    const [disclosuresDto, setDisclosuresDto] = useState<IDisclosuresActionsDetailsDto>(null);
    const [enquiriesDto, setEnquiriesDto] = useState<IEnquiriesActionsDetailsDto>(null);

    const config = useAppConfigContext();
    const orgAdminLink = config.vivliOrganizationAdminResourcesLink;

    useEffect(() => {
        if (!awaitingActionsResults) {
            return;
        }
        setRequestsDto(awaitingActionsResults?.requests);
        setDisclosuresDto(awaitingActionsResults?.disclosures);
        setEnquiriesDto(awaitingActionsResults?.enquiries);
    }, [awaitingActionsResults]);

    return (
        <div style={{ height: '100%', overflowX: 'auto', overflowY: 'hidden', marginBottom: '50px' }}>
            <DashboardAdminComponent
                requestsUploadsActionsDto={requestsDto}
                disclosuresActionsDto={disclosuresDto}
                enquiriesActionsDto={enquiriesDto}
                headerLink={orgAdminLink}
            />
        </div>
    );
};
